import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Kosten, kostenBezeichnungWithBoundary } from '../../../model/kosten';
import { FacettenUrlService } from '../facetten.url.service';

@Injectable({
  providedIn: 'root'
})
export class KostenUrlService extends FacettenUrlService {
  public static URL_PARAMETER = 'kosten';

  constructor() {
    super(KostenUrlService.URL_PARAMETER, 'kosten');
  }

  public override get selectedOptionIds$(): Observable<string[]> {
    return this.selectedOptions$.pipe(map(this.mapIdsToBackendIds));
  }

  /**
   * Mappt IDs (aus der URL) zu backendIds (Kommunikation zw. UI und Backend)
   * @param ids
   * @returns
   */
  private mapIdsToBackendIds(ids: string[]): Kosten[] {
    return ids
      .map(
        (id) => kostenBezeichnungWithBoundary.find((option) => option.id === id)?.backendId || null
      )
      .filter((item) => !!item);
  }
}
